// extracted by mini-css-extract-plugin
export var dividerContainer = "_9m-0";
export var line = "_9m-1";